interface SmallColorPaletteIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

/**
 * Version of the color palette icon which is intended to be used in contexts where it is
 * displayed at a smaller size.
 */
export const SmallColorPaletteIcon = ({
  color = 'currentColor',
  ...props
}: SmallColorPaletteIconProps) => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 12 12"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    strokeWidth={0.75}
    {...props}
  >
    <path
      d="M6.5195 9.67345L6.02215 9.72484L6.5195 9.67345ZM9.67927 6.51316L9.62921 7.01064L9.67927 6.51316ZM7.125 7.125L7.47855 7.47855L7.125 7.125ZM6 11.375C6.22161 11.375 6.45088 11.3319 6.64726 11.196C6.85194 11.0544 6.95856 10.8557 7.01033 10.6662C7.05919 10.4874 7.06436 10.3 7.05881 10.1369C7.05316 9.97108 7.03431 9.79092 7.01686 9.62205L6.02215 9.72484C6.04055 9.9029 6.05514 10.0464 6.05939 10.1709C6.06372 10.2981 6.05522 10.3678 6.0457 10.4026C6.03908 10.4268 6.04262 10.3983 6.07835 10.3736C6.10577 10.3547 6.10023 10.375 6 10.375V11.375ZM0.625 6C0.625 8.96853 3.03147 11.375 6 11.375V10.375C3.58375 10.375 1.625 8.41625 1.625 6H0.625ZM6 0.625C3.03147 0.625 0.625 3.03147 0.625 6H1.625C1.625 3.58375 3.58375 1.625 6 1.625V0.625ZM11.375 6C11.375 3.03147 8.96853 0.625 6 0.625V1.625C8.41625 1.625 10.375 3.58375 10.375 6H11.375ZM9.62921 7.01064C9.79737 7.02757 9.9766 7.04584 10.1415 7.05114C10.3038 7.05635 10.4899 7.05096 10.6674 7.0027C10.8551 6.95165 11.0535 6.84654 11.1953 6.64349C11.3317 6.44812 11.375 6.21997 11.375 6H10.375C10.375 6.09678 10.3552 6.09984 10.3754 6.07095C10.4009 6.03436 10.4298 6.03098 10.405 6.03773C10.37 6.04726 10.3003 6.05572 10.1736 6.05165C10.0496 6.04767 9.90661 6.03351 9.72934 6.01567L9.62921 7.01064ZM7.47855 7.47855C8.08031 6.87679 8.83473 6.93068 9.62921 7.01064L9.72934 6.01567C8.98862 5.94112 7.74861 5.79428 6.77145 6.77145L7.47855 7.47855ZM7.01686 9.62205C6.93481 8.82808 6.87946 8.07765 7.47855 7.47855L6.77145 6.77145C5.79561 7.74728 5.94572 8.98519 6.02215 9.72484L7.01686 9.62205ZM3.75 9.125C4.44036 9.125 5 8.56536 5 7.875H4C4 8.01307 3.88807 8.125 3.75 8.125V9.125ZM2.5 7.875C2.5 8.56536 3.05964 9.125 3.75 9.125V8.125C3.61193 8.125 3.5 8.01307 3.5 7.875H2.5ZM3.75 6.625C3.05964 6.625 2.5 7.18464 2.5 7.875H3.5C3.5 7.73693 3.61193 7.625 3.75 7.625V6.625ZM5 7.875C5 7.18464 4.44036 6.625 3.75 6.625V7.625C3.88807 7.625 4 7.73693 4 7.875H5ZM4 5.0625C4 5.30412 3.80412 5.5 3.5625 5.5V6.5C4.35641 6.5 5 5.85641 5 5.0625H4ZM3.5625 4.625C3.80412 4.625 4 4.82088 4 5.0625H5C5 4.26859 4.35641 3.625 3.5625 3.625V4.625ZM3.125 5.0625C3.125 4.82088 3.32088 4.625 3.5625 4.625V3.625C2.76859 3.625 2.125 4.26859 2.125 5.0625H3.125ZM3.5625 5.5C3.32088 5.5 3.125 5.30412 3.125 5.0625H2.125C2.125 5.85641 2.76859 6.5 3.5625 6.5V5.5ZM6.375 5C7.27246 5 8 4.27246 8 3.375H7C7 3.72018 6.72018 4 6.375 4V5ZM4.75 3.375C4.75 4.27246 5.47754 5 6.375 5V4C6.02982 4 5.75 3.72018 5.75 3.375H4.75ZM6.375 1.75C5.47754 1.75 4.75 2.47754 4.75 3.375H5.75C5.75 3.02982 6.02982 2.75 6.375 2.75V1.75ZM8 3.375C8 2.47754 7.27246 1.75 6.375 1.75V2.75C6.72018 2.75 7 3.02982 7 3.375H8Z"
      fill={color}
    />
  </svg>
);

interface ColorPaletteIconProps extends React.ComponentPropsWithoutRef<'svg'> {
  color?: string;
}

export const ColorPaletteIcon = ({
  color = 'currentColor',
  ...svgProps
}: ColorPaletteIconProps) => (
  <svg
    width="32"
    height="32"
    viewBox="0 0 32 32"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    stroke={color}
    {...svgProps}
  >
    <circle cx="17" cy="9" r="3" />
    <circle cx="9.5" cy="13.5" r="2.5" />
    <circle cx="10" cy="21" r="1.9" />
    <path
      d="M28.2,17.3c-1.8,0.7-5.1-1.2-8.3,1c-1.8,1.2-2.7,3.2-2.7,5.9c0,2.1,0.7,4-0.1,4.6c-1.3,1-8.7,0-12.1-5.8
	C1.6,17.1,2.8,10.5,7,6.5c3.8-3.6,9.7-4.6,14.8-2.2c6.8,3.3,7.1,10,7.2,11.1C29.1,16.3,29.1,17,28.2,17.3z"
    />
  </svg>
);